import React, { useRef, useState } from "react";

export default function BeforeAfter({ before, after }) {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);
  const dragging = useRef(false);

  const move = (clientX) => {
    const r = ref.current.getBoundingClientRect();
    const p = ((clientX - r.left) / r.width) * 100;
    setPos(Math.max(0, Math.min(100, p)));
  };

  return (
    <div
      ref={ref}
      data-testid="before-after"
      className="relative w-full aspect-[16/10] overflow-hidden rounded-xl2 border border-line select-none cursor-ew-resize"
      onMouseMove={(e) => dragging.current && move(e.clientX)}
      onMouseDown={(e) => { dragging.current = true; move(e.clientX); }}
      onMouseUp={() => (dragging.current = false)}
      onMouseLeave={() => (dragging.current = false)}
      onTouchMove={(e) => move(e.touches[0].clientX)}
    >
      <img src={after} alt="After" className="absolute inset-0 w-full h-full object-cover" />
      <span className="absolute top-3 right-3 bg-gold text-white text-xs font-bold px-3 py-1 rounded-full">AFTER</span>
      <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
        <img src={before} alt="Before" className="absolute inset-0 h-full object-cover" style={{ width: `${100 / (pos / 100)}%`, maxWidth: "none" }} />
        <span className="absolute top-3 left-3 bg-ink text-white text-xs font-bold px-3 py-1 rounded-full">BEFORE</span>
      </div>
      <div className="absolute top-0 bottom-0 w-0.5 bg-white shadow-lift" style={{ left: `${pos}%` }}>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white shadow-lift flex items-center justify-center text-ink font-bold">⇔</div>
      </div>
    </div>
  );
}
